import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "news-service";

export default {
    getNews(page = 1) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/news/merchant/all/" + page,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCategories() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/news/merchant/categories",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    search(param, page = 1) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/news/merchant/search/" + page,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    saveNews(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/news/merchant/create",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    deleteNews(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(
                BASE_SERVICE_URL + "/news/merchant/delete/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    viewNews(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/news/merchant/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateNews(uuid, param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/news/merchant/update/" + uuid,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
